import { Component } from "react"
import PropTypes from "prop-types"
import { combineReducers, createStore } from "redux"
import { Provider } from "react-redux"

import ErrorBoundary from "../../../shared/components/error_boundary"
import OrganizationDetails from "./organization_details"
import OrganizationMembership from "./organization_membership"
import PlatformInvoiceList from "./platform_invoice/platform_invoice_list"
import SpaContainer from "../single_page_app/spa_container"
import SpaSidebarNav from "../single_page_app/spa_sidebar_nav"

import orgReducers from "./reducers"
import {
  updateOrgName,
  updateOrgOwner,
  updateOrgMembers,
  updateOrgInvites,
  updateOrgInviteCount,
} from "./actions"
import { updateActiveView } from "../single_page_app/actions"
import { activeView } from "../single_page_app/reducers"

export default class OrganizationContainer extends Component {
  constructor(props) {
    super(props)
    const details = orgReducers.details
    const membership = orgReducers.membership
    const combinedReducers = combineReducers({
      details,
      membership,
      activeView,
    })

    const navItems = [
      {
        key: "details",
        content: "Details",
      },
      {
        key: "team",
        content: "Team",
      },
    ]

    // we will eventually rename lite to developer in the database
    // https://ifttt-dev.atlassian.net/browse/SP-249
    if (this.props.org.tier == "lite" || this.props.org.tier == "developer") {
      navItems.push({
        key: "invoices",
        content: "Invoices",
      })
    }

    this.state = {
      navItems,
    }
    this.store = createStore(combinedReducers)
  }
  UNSAFE_componentWillMount() {
    // Initial state
    this.store.dispatch(updateOrgName(this.props.org.name))
    this.store.dispatch(
      updateOrgOwner({
        id: this.props.org.owner.id,
        login: this.props.org.owner.login,
        email: this.props.org.owner.email,
      })
    )
    this.store.dispatch(updateOrgMembers(this.props.org.users))
    this.store.dispatch(
      updateOrgInvites({
        pending: this.props.org.pending_invitations,
        expired: this.props.org.expired_invitations,
      })
    )
    this.store.dispatch(
      updateOrgInviteCount(this.props.org.remaining_invitations)
    )
    // it's important that there be at least one dispatch after this call
    // so the check can run once
    this.store.subscribe(() => {
      if (
        this.store.getState().details.orgOwner.id !==
          this.props.currentUserId &&
        this.state.navItems.length > 2
      ) {
        this.setState({
          navItems: this.state.navItems.slice(0, 3),
        })
      }
    })
    this.store.dispatch(updateActiveView(this.props.initialView.toLowerCase()))
  }

  render() {
    return (
      <Provider store={this.store}>
        <div className="main-content">
          <SpaSidebarNav items={this.state.navItems} />
          <div className="main-content-column">
            <SpaContainer initialView={this.props.initialView}>
              <ErrorBoundary key="details">
                <OrganizationDetails
                  currentUserId={this.props.currentUserId}
                  org={this.props.org}
                  plansPath={this.props.plansPath}
                />
              </ErrorBoundary>

              <ErrorBoundary key="team">
                <OrganizationMembership
                  orgId={this.props.org.id}
                  orgName={this.props.org.name}
                  currentUserId={this.props.currentUserId}
                  clearCachePath={this.props.clearCachePath}
                  plansPath={this.props.plansPath}
                />
              </ErrorBoundary>

              <ErrorBoundary key="invoices">
                <PlatformInvoiceList
                  organization={this.props.org}
                  stripeKey={this.props.stripeKey}
                  invoices={this.props.invoices}
                  plansPath={this.props.plansPath}
                />
              </ErrorBoundary>
            </SpaContainer>
          </div>
        </div>
      </Provider>
    )
  }
}

OrganizationContainer.propTypes = {
  clearCachePath: PropTypes.string,
  currentUserId: PropTypes.string,
  initialView: PropTypes.string,
  invoices: PropTypes.array,
  org: PropTypes.object,
  plansPath: PropTypes.string.isRequired,
  stripeKey: PropTypes.string,
}
